// extracted by mini-css-extract-plugin
export default {"bg":"OurServices_bg__kNUVO","img":"OurServices_img__e0MtG","parentContainer":"OurServices_parentContainer__Ixvqp","serviceDescription":"OurServices_serviceDescription__24Ccx"};